import { ROLES } from '@/models/Rolle';
import ImportStatusView from '@/views/auth/berechnungen/import_status/IndexView.vue';
import GebaeudeListView from '@/views/auth/berechnungen/gebaeude/GebauedelisteView.vue';
import EnergieverbrauchView from '@/views/auth/berechnungen/gebaeude/EnergieverbrauchView.vue';
import StromerzeugungsanlagenView from '@/views/auth/berechnungen/produktion/StromerzeugungsanlagenView.vue';

export default [
    {
        path: '/berechnungen/import_status',
        name: 'ber_import_status',
        component: ImportStatusView,
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungen],
        },
    },
    {
        path: '/berechnungen/gebaeude',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnete_listen],
        },
        children: [
            {
                path: 'gebaeudeliste',
                name: 'ber_geb_list',
                component: GebaeudeListView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnete_listen],
                },
            },
            {
                path: 'energieverbrauchliste',
                name: 'ber_geb_ev',
                component: EnergieverbrauchView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnete_listen],
                },
            },
        ],
    },
    {
        path: '/berechnungen/produktion',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnete_listen],
        },
        children: [
            {
                path: 'stromerzeugungsanlagenliste',
                name: 'ber_prod_sa',
                component: StromerzeugungsanlagenView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnete_listen],
                },
            },
        ],
    },
];

